import { useCallback, useEffect, useState } from 'react';
import { BrandMark } from '../../ui/BrandMark';
import { Pattern } from './screens';
import s from './auth.module.css';

interface Props {
  /** Signs in once more with the same initData: the browser gets its own token, so its «Выйти» keeps this session. */
  prepare: () => Promise<string>;
  /** Opens the browser with the token in the URL fragment (Telegram.WebApp.openLink). */
  open: (token: string) => void;
  onContinue: () => void;
}

type State = { kind: 'preparing' } | { kind: 'ready'; token: string } | { kind: 'failed' } | { kind: 'opened' };

/**
 * The mini app opened from «Войти через Telegram» in a browser (`startapp=web_<state>`, #4218). The token is
 * fetched before the tap: Telegram clients open links only right from a user's gesture.
 */
export function WebHandoffScreen({ prepare, open, onContinue }: Props) {
  const [state, setState] = useState<State>({ kind: 'preparing' });

  const load = useCallback(() => {
    setState({ kind: 'preparing' });
    prepare().then(
      (token) => setState({ kind: 'ready', token }),
      () => setState({ kind: 'failed' }),
    );
  }, [prepare]);

  useEffect(load, [load]);

  return (
    <main className={s.screen}>
      <Pattern />
      <BrandMark />
      <h1 className={s.title}>Вход в браузере</h1>
      <p className={s.lead}>
        {state.kind === 'opened'
          ? 'Вернитесь в браузер — вы уже вошли.'
          : state.kind === 'failed'
            ? 'Не получилось подготовить вход. Проверьте интернет и попробуйте снова.'
            : 'Вы вошли в PASS24 по номеру из Telegram. Откройте приложение в браузере — вход сохранится на год.'}
      </p>
      <div className={s.spacer} />
      <div className={s.actions}>
        {state.kind === 'failed' ? (
          <button type="button" className={s.primary} onClick={load}>
            Повторить
          </button>
        ) : (
          state.kind !== 'opened' && (
            <button
              type="button"
              className={s.primary}
              disabled={state.kind !== 'ready'}
              onClick={() => {
                if (state.kind !== 'ready') return;
                open(state.token);
                setState({ kind: 'opened' });
              }}
            >
              Открыть PASS24 в браузере
            </button>
          )
        )}
        <button type="button" className={s.link} onClick={onContinue}>
          Продолжить в Telegram
        </button>
      </div>
    </main>
  );
}
